import script from "./MiNTNewsOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./MiNTNewsOverview.vue?vue&type=script&setup=true&lang=js"

import "./MiNTNewsOverview.vue?vue&type=style&index=0&id=2907b71d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2907b71d"]])

export default __exports__